import React, { lazy } from "react";
import { Layout } from "../components/layout";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { getPageLocale, isCN } from "@monorepo/utils/locales";

const LoginEmailSubscriber = lazy(() => import("../pages/LoginScreens/EmailSubscriberLogin"));
const VerifyEmail = lazy(() => import("../pages/VerifyEmail/VerifyEmail"));
const ProfileAndInterests = lazy(() => import("../pages/ProfileAndInterests"));
const ProfileName = lazy(() => import("../pages/ProfileAndInterests/ProfileName"));
const Industry = lazy(() => import("../pages/ProfileAndInterests/Industry"));
const JobRole = lazy(() => import("../pages/ProfileAndInterests/JobRole"));
const Organization = lazy(() => import("../pages/ProfileAndInterests/Organization"));
const DevBusTOI = lazy(() => import("../pages/ProfileAndInterests/DevBusTOI"));
const GamingTOI = lazy(() => import("../pages/ProfileAndInterests/GamingTOI"));
const PreferredLanguage = lazy(() => import("../pages/ProfileAndInterests/PreferredLanguage"));
const Location = lazy(() => import("../pages/ProfileAndInterests/Location"));
const Communications = lazy(() => import("../pages/Communications"));
const Gaming = lazy(() => import("../pages/Communications/Gaming"));
const Developer = lazy(() => import("../pages/Communications/Developer"));
const Startup = lazy(() => import("../pages/Communications/Startup"));
const Enterrpise = lazy(() => import("../pages/Communications/Enterprise"));
const PrivacySettings = lazy(() => import("../pages/PrivacySettings"));
const RequestData = lazy(() => import("../pages/PrivacySettings/RequestData"));
const DeleteData = lazy(() => import("../pages/PrivacySettings/DeleteData"));
const InterestBasedAds = lazy(() => import("../pages/PrivacySettings/InterestBasedAds"));

const routes = [
    {
        element: (
            <Layout>
                <Outlet />
            </Layout>
        ),
        children: [
            {
                path: "/",
                Component: LoginEmailSubscriber,
            },
            { path: "/verify-email", Component: VerifyEmail },
        ],
    },
    // { path: "/login/account", Component: <div>Account login page</div> },
    // { path: "/login/email-subscribers", Component: <div>Email subscribers login page</div> },
    {
        element: (
            <Layout>
                <ProtectedRoute />
            </Layout>
        ),
        //errorElement: <ParentErrorBoundary />,
        children: [
            {
                path: "/privacy-settings/",
                Component: PrivacySettings,
                //errorElement: <RewardErrorBoundary />,
            },
            {
                path: "/profile-interests/",
                Component: ProfileAndInterests,
                //errorElement: <RewardErrorBoundary />,
            },
            { path: "/profile-interests/profile-name", Component: ProfileName },
            { path: "/profile-interests/industry", Component: Industry },
            { path: "/profile-interests/job-title", Component: JobRole },
            { path: "/profile-interests/organization", Component: Organization },
            {
                path: "/profile-interests/enterprise",
                Component: DevBusTOI,
            },
            {
                path: "/profile-interests/gaming",
                Component: GamingTOI,
            },
            {
                path: "/profile-interests/preferred-language",
                Component: PreferredLanguage,
            },
            {
                path: "/profile-interests/location",
                Component: Location,
            },
            {
                path: "/communications/",
                Component: Communications,
            },
            {
                path: "/communications/gaming",
                Component: Gaming,
            },
            {
                path: "/communications/developer",
                Component: Developer,
            },
            {
                path: "/communications/startup",
                Component: Startup,
            },
            {
                path: "/communications/enterprise",
                Component: Enterrpise,
            },
            {
                path: "/privacy-settings/",
                Component: PrivacySettings,
            },
            {
                path: "/privacy-settings/request-data",
                Component: RequestData,
            },
            {
                path: "/privacy-settings/delete-data",
                Component: DeleteData,
            },
            {
                path: "/privacy-settings/interest-based-ads",
                Component: InterestBasedAds,
            },
        ],
    },
    { path: "*", element: <Navigate to={"/"} /> },
];

export const router = createBrowserRouter(routes, {
    basename: isCN() ? "/privacy/" : `/${getPageLocale()}/privacy/`,
});
